import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getCallsCosts, updateCallsCosts} from 'src/openapi/admin/apis/CallCostControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {CallCostGroupList} from 'src/openapi/admin/models/CallCostGroupList';
import type {PricingModel} from 'src/openapi/admin/models/PricingModel';

type Props = {
    accountId: number,
    pricingModel: PricingModel,
};

export const useCallCosts = ({accountId, pricingModel}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getCallsCosts({accountId, pricingModel}),
    ), [accountId, pricingModel, apiDispatch]);

    const saveDispatchAction = useCallback((list: CallCostGroupList) => apiDispatch(
        updateCallsCosts({accountId, pricingModel, callCostGroup: list.callsCosts}),
    ), [accountId, pricingModel, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            callsCosts: [],
            changesInfo: {
                createdBy: null,
                updatedBy: null,
                createdAt: null,
                updatedAt: null,
            },
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
